import React from 'react';
import * as Scrivito from 'scrivito';

// Maps CMS color enum values to the original Rails CSS background classes
const COLOR_CLASSES = {
  white: 'trans-tech-white',
  grey: 'trans-tech-grey',
  very_light: 'trans-tech-blue-superlight',
  light: 'trans-tech-blue-light',
  dark: 'trans-tech-blue-dark',
  'very dark': 'trans-tech-blue-darker',
};

Scrivito.provideWidgetClass('ContainerWidget', {
  attributes: {
    widgets: 'widgetlist',
    color: ['enum', { values: ['white', 'grey', 'very_light', 'light', 'dark', 'very dark'] }],
    sectionName: 'string',
    title: 'string',
    includeInNav: ['enum', { values: ['ja', 'nein'] }],
  },
});

const ContainerWidget = Scrivito.connect(({ widget }) => {
  const color = widget.get('color');
  const sectionName = widget.get('sectionName');

  const colorClass = COLOR_CLASSES[color] || '';

  return (
    // The Rails partial put the colour on a .row between the section and the
    // container, not on the section itself. The row's negative 15px margins are
    // load-bearing: below 768px, where .container has no fixed width, they let the
    // content span the full viewport. Without them every section was 30px
    // narrower on a phone, so the text wrapped more often and the page grew by
    // some 230px.
    <section>
      <a className="anchor" id={sectionName || undefined} />
      <div className={`row ${colorClass}`}>
        <div className={`container container_padding ${colorClass}`}>
          <Scrivito.ContentTag tag="div" attribute="widgets" content={widget} />
        </div>
      </div>
    </section>
  );
});

Scrivito.provideComponent('ContainerWidget', ContainerWidget);

Scrivito.provideEditingConfig('ContainerWidget', {
  title: 'Section Container',
  properties: ['color', 'sectionName', 'title', 'includeInNav'],
  attributes: {
    color: {
      title: 'Background Color',
      values: [
        { value: 'white',      title: 'White' },
        { value: 'grey',       title: 'Light Grey' },
        { value: 'very_light', title: 'Blue Superlight' },
        { value: 'light',      title: 'Blue Light' },
        { value: 'dark',       title: 'Blue Dark' },
        { value: 'very dark',  title: 'Blue Darker' },
      ],
    },
    sectionName:  { title: 'Section ID', description: 'Used for anchor links (e.g. "request_information"). No spaces.' },
    title:        { title: 'Navigation Title', description: 'Label shown in the page navigation.' },
    includeInNav: {
      title: 'Show in Navigation',
      values: [
        { value: 'ja',   title: 'Yes' },
        { value: 'nein', title: 'No' },
      ],
    },
    widgets: { title: 'Content' },
  },
  initialContent: {
    color: 'grey',
    includeInNav: 'ja',
  },
});

export default ContainerWidget;
